import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DOCOnlineTechSkillItem from "./DOCOnlineTechSkillItem";
import DOCOnlineOtherTechSkillItem from "./DOCOnlineOtherTechSkillItem";
import ComboBox from "../../../../components/ComboBox";
import DraggableList from "react-draggable-list";

const DOCOnlineTechSkillsList = ({
  docOnline,
  setDocOnline,
  errors,
  comboBoxList,
  skillLevels,
  yearsExperience,
  techSkills,
  techSkillsHasLoaded
}) => {
  const containerRef = useRef();

  const [selectedSkill, setSelectedSkill] = useState();

  const { t } = useTranslation();
  const [existingTech, setExistingTech] = useState(false);

  useEffect(() => {
    if (techSkillsHasLoaded) {
      let _competences = [...docOnline.competences];
      _competences.map((item, index) => {
        item.order = index + 1;
      });
      setDocOnline({ ...docOnline, competences: _competences });
    }
  }, [techSkillsHasLoaded]);

  function addSelectedSkill() {
    AddSkillByDescription(selectedSkill);
  }

  function AddSkillByDescription(skillDescription) {
    if (existingTech) {
      let skill = techSkills
        .filter((x) => x.description === skillDescription)
        .shift();
      if (!skill) toast.warning(t("Skill does not exist"));
      else {
        addSkill({
          ...skill,
          skillExperienceTimeId: undefined,
          skillLevelId: undefined
        });
        setSelectedSkill([]);
      }
    } else {
      addOtherCompetence(skillDescription);
    }
  }

  function CreateDataContext(skill) {
    return {
      id: 0,
      skillId: skill.id,
      skillExperienceTimeId: parseInt(skill.skillExperienceTimeId),
      skillLevelId: skill.skillLevelId,
      docGeneralId: 0,
      description: skill.description
    };
  }

  function addSkill(skill) {
    let repete = docOnline.competences.filter(
      (x) => x.description === skill.description
    );

    if (repete.length > 0) {
      toast.warning(t("Skill is already registered"));
      return;
    } else {
      let _competences = [...docOnline.competences];
      _competences.push(CreateDataContext(skill));
      onListOrderChange(_competences);
    }
  }

  function deleteTechSkill(toRemove) {
    let _competences = [...docOnline.competences];
    let index = _competences.findIndex((x) => x.skillId === toRemove.skillId);
    if (index > -1) {
      _competences.splice(index, 1);

      _competences.map((item, index) => {
        item.order = index + 1;
      });
      setDocOnline({ ...docOnline, competences: _competences });
    }
  }

  function onChangeData(target) {
    let _competences = [...docOnline.competences];
    let indexToChange = _competences.findIndex((x) => x.skillId === target.key);

    if (indexToChange > -1) {
      _competences[indexToChange][target.name] = target.value;
      onListOrderChange(_competences);
    }
  }

  function onChangeOtherCompetence(otherCompetences) {
    let _otherCompetences = [...docOnline.otherCompetences];
    let indexToChange = _otherCompetences.findIndex(
      (x) => x.description === otherCompetences.key // Never do not change to x.skillId
    );
    _otherCompetences[indexToChange][otherCompetences.name] =
      otherCompetences.value;
    setDocOnline({ ...docOnline, otherCompetences: _otherCompetences });
  }
  function onSelectedSkillChange({ target }) {
    setSelectedSkill(target.value);
    let _existingTech = techSkills.filter(
      (x) => x.description === target.value
    );
    setExistingTech(_existingTech.length > 0);
  }
  function deleteOtherCompetence(otherCompetence) {
    let _otherCompetences = [...docOnline.otherCompetences];
    let index = _otherCompetences.indexOf(otherCompetence);
    if (index > -1) _otherCompetences.splice(index, 1);
    setDocOnline({ ...docOnline, otherCompetences: _otherCompetences });
  }
  function addOtherCompetence(skillDescription) {
    if (skillDescription && skillDescription.trim().length > 0) {
      let alreadyAdded = docOnline.otherCompetences
        .filter((x) => x.description === skillDescription)
        .shift();
      if (alreadyAdded) {
        toast.warning(t("Skill is already registered"));
        return;
      }
      let _otherCompetences = [...docOnline.otherCompetences];

      let skillId = -_otherCompetences.length;
      _otherCompetences.push({
        skillId: skillId,
        description: skillDescription,
        skillExperienceTimeId: undefined,
        skillLevelId: undefined
      });
      setDocOnline({ ...docOnline, otherCompetences: _otherCompetences });
      setSelectedSkill();
    }
  }
  function onListOrderChange(data) {
    data.map((item, index) => {
      item.order = index + 1;
    });

    setDocOnline({ ...docOnline, competences: data });
  }

  function rowTemplate({ item, itemSelected, dragHandleProps }) {
    const { onMouseDown, onTouchStart } = dragHandleProps;
    return (
      <DOCOnlineTechSkillItem
        techSkill={item}
        deleteTechSkill={() => deleteTechSkill(item)}
        yearsExperience={yearsExperience}
        skillLevels={skillLevels}
        onChangeData={onChangeData}
        errors={errors}
        withIndex={true}
      >
        {" "}
        <div
          className=" pt-1 col-1"
          role="button"
          onTouchStart={(e) => {
            e.preventDefault();

            onTouchStart(e);
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            onMouseDown(e);
          }}
        >
          <i class="bi bi-grip-vertical"></i>
        </div>
      </DOCOnlineTechSkillItem>
    );
  }

  return (
    <section className="step">
      <h3 className="title-style">
        {t("Tech skills, frameworks and methodologies")}
      </h3>
      <div className="doc-subtitle subtitle-style">
        {t(
          "Please add and evaluate your programming language skills, frameworks, methodologies or other tools that you are aware of. Rate them according to the Level of competence (Level 1. Basic; 2. Intermediate; 3.Independent, 4. Specialist) and enter the Duration of Experience (years)."
        )}
      </div>
      <div className="card inboard p-3">
        <div className="mb-3">
          <label style={{ marginTop: "-10px" }}>
            {t("Skills")}
            <label className="star-style">*</label>
          </label>
          <div className="row mb-2 align-items-center">
            <div className="col">
              <ComboBox
                value={selectedSkill}
                list={comboBoxList}
                onChange={onSelectedSkillChange}
              />
            </div>
            <div className="col">
              <button
                type="button"
                onClick={addSelectedSkill}
                className="app-button btn-prime btn-md"
              >
                {existingTech === true ? t("Add") : t("Create")}
              </button>
            </div>
          </div>
          <article className="tech-skills">
            <div className=" row">
              <div className=" col-1">#</div>
              <div className=" col-3">{t("Name")}</div>
              <div className="col-2">{t("Experience time")}</div>
              <div className=" col-4 text-center">{t("Level ")}</div>
              <div className="col"></div>
            </div>
            <hr />
            {errors !== undefined &&
              errors.DOCOnlineTechSkill !== undefined &&
              errors.DOCOnlineTechSkill && (
                <span className="error-msg">{errors.DOCOnlineTechSkill}</span>
              )}
            <div className="competence" ref={containerRef}>
              <DraggableList
                itemKey="skillId"
                template={rowTemplate}
                list={docOnline.competences}
                onMoveEnd={(newList) => onListOrderChange(newList)}
                container={() => containerRef.current}
              />
            </div>

            {/* Others Comptence goes here */}

            {docOnline.otherCompetences.length > 0 && (
              <div className="competence">
                <div className="mt-2">
                  <strong>{t("Others")}</strong>
                  {docOnline.otherCompetences.map((otherCompetence, index) => (
                    <DOCOnlineOtherTechSkillItem
                      key={otherCompetence.skillId}
                      techSkill={otherCompetence}
                      deleteTechSkill={() =>
                        deleteOtherCompetence(otherCompetence)
                      }
                      yearsExperience={yearsExperience}
                      skillLevels={skillLevels}
                      onChangeData={onChangeOtherCompetence}
                      errors={errors.otherCompetences ? errors.otherCompetences[index] : undefined}
                    >
                      {" "}
                      <div className="col-1"></div>
                    </DOCOnlineOtherTechSkillItem>
                  ))}
                </div>
              </div>
            )}
          </article>
        </div>
      </div>
      <div style={{ color: "red" }}>
        <label className="star-style">*</label>{" "}
        <label style={{ marginLeft: "20px" }}>{t("Required field")}</label>
      </div>
    </section>
  );
};

export default DOCOnlineTechSkillsList;
